import { EInput } from '@components/Input';
import { Form, Input } from '@components/Input';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { authQueries } from '@queries/index';
import z from 'zod';
import type { LoginRequest } from '@services/api';
import { Button } from '@components/Button';
import { useState } from 'react';
import { AlertCircle } from 'lucide-react';
import { toast } from 'sonner';

const schema = z.object({
  email: z.string().min(1, 'Email é obrigatório').email('Email inválido'),
  password: z.string().min(1, 'Senha é obrigatória'),
});

type FormData = z.infer<typeof schema>;

function getLoginErrorMessage(error: unknown): string {
  const apiError = error as { status?: number; message?: string } | null;

  switch (apiError?.status) {
    case 400:
    case 401:
    case 403:
    case 422:
      return 'Login ou senha inválidos';
    case 429:
      return 'Muitas tentativas. Tente novamente mais tarde';
    default:
      return apiError?.message || 'Não foi possível entrar. Tente novamente';
  }
}

export function LoginForm() {
  const { mutate: login, isPending } = authQueries.useLogin();
  const [loginError, setLoginError] = useState<string | null>(null);
  const methods = useForm<FormData>({
    resolver: zodResolver(schema),
  });

  function handleLogin(data: FormData) {
    setLoginError(null);

    const objToSend: LoginRequest = {
      login: data.email,
      senha: data.password,
      channel: 'web',
    };

    login(objToSend, {
      onSuccess: (response) => {
        console.log('Login realizado com sucesso no fila:', response);
        // A navegação será feita pela rota que usar este componente
      },
      onError: (error) => {
        console.error('Erro no login:', error);
        const status = (error as { status?: number } | null)?.status;
        const message = getLoginErrorMessage(error);
        setLoginError(message);
        // O apiClient já exibe toast global para os demais status; o 401 é tratado aqui.
        if (status === 401) {
          toast.error(message);
        }
        methods.setValue('password', '');
      },
    });
  }

  return (
    <Form ctx={methods} onSubmit={handleLogin}>
      {loginError && (
        <div
          role="alert"
          aria-live="assertive"
          className="flex items-start gap-2 rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-700">
          <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
          <span>{loginError}</span>
        </div>
      )}

      <Input type={EInput.EMAIL} name="email" label="E-mail" placeholder="Digite seu e-mail" />

      <Input type={EInput.PASSWORD} name="password" label="Senha" placeholder="Digite sua senha" />

      <Button type="submit" variant="success" size="lg" className="mt-2 w-full" loading={isPending}>
        Entrar
      </Button>
    </Form>
  );
}